import { isCountedStockTakeLine } from './stockTakeCountFlag'

const asId = value => {
  if (value == null || value === '') return ''
  if (typeof value === 'object') {
    return String(value._id || value.id || '').trim()
  }
  return String(value).trim()
}

const normalize = value =>
  String(value || '')
    .trim()
    .toLowerCase()

export const packFamilyKey = line =>
  `${normalize(line?.title)}|${normalize(
    line?.supplierTitle || asId(line?.supplierId),
  )}`

export const formatOtherPacksToggleLabel = (hiddenCount, expanded) => {
  if (!(Number(hiddenCount) > 0)) return ''
  if (expanded) return 'Hide other packs'
  return Number(hiddenCount) === 1
    ? 'Show 1 other pack'
    : `Show ${hiddenCount} other packs`
}

/** UI-only: keep unused conversion lines on the take, hide them in the grid. */
export const listVisibleStockTakePackLines = (
  lines = [],
  { collapse = true } = {},
) => {
  const list = Array.isArray(lines) ? lines : []
  if (!collapse) {
    return { visible: list, hiddenCount: 0 }
  }

  const groups = new Map()
  list.forEach((line, index) => {
    const key = packFamilyKey(line)
    const groupKey = !key || key === '|' ? `__solo_${index}` : key
    const group = groups.get(groupKey) || []
    group.push({ line, index })
    groups.set(groupKey, group)
  })

  const hide = new Set()
  for (const group of groups.values()) {
    if (group.length < 2) continue
    const counted = group.filter(({ line }) => isCountedStockTakeLine(line))
    const keep = new Set(
      counted.length
        ? counted.map(item => item.index)
        : [(group.find(({ line }) => line?.preferredPack) || group[0]).index],
    )
    group.forEach(item => {
      if (!keep.has(item.index)) hide.add(item.index)
    })
  }

  return {
    visible: list.filter((_, index) => !hide.has(index)),
    hiddenCount: hide.size,
  }
}

export const groupStockTakePackFamilies = (lines = []) => {
  const list = Array.isArray(lines) ? lines : []
  const groups = new Map()
  list.forEach((line, index) => {
    const key = packFamilyKey(line)
    const groupKey = !key || key === '|' ? `__solo_${index}` : key
    const group = groups.get(groupKey) || []
    group.push(line)
    groups.set(groupKey, group)
  })
  return [...groups.values()]
}

/** Progress pill: unique products / last-ordered pack families, not conversion rows. */
export const summarizeStockTakeProductProgress = (lines = []) => {
  const list = Array.isArray(lines) ? lines : []
  const families = groupStockTakePackFamilies(list)
  const counted = families.filter(family =>
    family.some(isCountedStockTakeLine),
  ).length
  return {
    counted,
    total: families.length,
    extraPackRows: Math.max(0, list.length - families.length),
  }
}
